import { connect } from "react-redux";
import { injectIntl } from "react-intl";

import { SeoRenderer } from "../../../common/helpers/seo";

import { changeSort, getResults, setSearch, setPage, setFilters, clearFilters } from "../../store/browse/actions";
import { IStateTree } from "../../store/interfaces";
import { IUser } from "../../store/user/models";

import loadableComponent from "./loadable";

const mapStateToProps = ({ browse, user }: IStateTree) => ({
    browse,
    user: user as IUser,
});

const mapDispatchToProps = { getResults, changeSort, setSearch, setPage, setFilters, clearFilters };

export default {
    component: injectIntl(connect(mapStateToProps, mapDispatchToProps)(loadableComponent)),
    renderSeo: (store: any, allMessage: {[key: string]: string}, lang: string) => {
        SeoRenderer({
            title: allMessage["menu.browse"],
            description: allMessage["browse.seo.description"],
            allMessage,
            lang,
        });
    },
};
